<form [formGroup]="sitFamForm" class="sitFamForm" >
    <div class="form-group">

        <!-- Situtation Familiale -->
        <ccd-boutons-radio
            name="situationFamiliale"
            libelle="Votre situation familiale"
            [configurationBoutons]="libelleLogement.situation_familiale_list"
            [valeur]="sitFamValue"
            (dataChange)="sitFamValue = $event"
            >
        </ccd-boutons-radio>

        <!-- Nombre d'enfants -->
        <div *ngIf="!sitFamForm.controls['situationFamiliale'].invalid" class="row">
            <div class="col-sm-4">
                <label class="label-form-cnaf control-label" for="nbEnfant">Nombre d'enfants</label>
                <div class="form-group input-group">
                    <div>
                        <button type="button" title="retirer un enfant" class="btn btn-majeur-cnaf float-start" (click)="clickBtnMoins()">-</button>
                    </div>
                    <div class="row col-sm-2">
                        <input class="form-control btn-plus" formControlName="nbEnfant" type="text" aria-live="polite">
                    </div>
                    <div>
                        <button type="button" title="ajouter un enfant" class="btn btn-majeur-cnaf" (click)="clickBtnPlus()">+</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</form>
